import { INTERNAL_SERVER_ERROR } from '../../constants/http';
import axios from '../../utils/axios';

const getClusters = async (type) => {
  try {
    const { data } = await axios.get(`/api/cluster${type ? `?type=${type}` : ''}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response
      ? err.response.status
      : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.statusText
      : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage:
          'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

export default {
  getClusters,
};
